import { call, put, select, takeLatest } from "redux-saga/effects";
import {fetchTechnologyLandscape } from "../../../services/accIqService";
import { FETCH_TECHLANDSCAPE_REQUEST, fetchTechlandScapeFailure, fetchTechlandScapeSuccess } from "../actions/techLandscapeActions";


// Worker Saga
function* fetchTechlandScapeSaga() {
  try {
    const payload = yield select(state=>state?.techLandscapeReducer?.payload);
    const data = yield call(fetchTechnologyLandscape,payload);

    yield put(fetchTechlandScapeSuccess(data));
  } catch (error) {
    yield put(fetchTechlandScapeFailure(error.message));
  }
}

// Watcher Saga
export function* watchFetchTechlandscape() {
  yield takeLatest(FETCH_TECHLANDSCAPE_REQUEST, fetchTechlandScapeSaga);
}
